export const TINY_MCE_API_KEY = 'agqnoxykado27w6h00g5es313yyo9g2t8x4gqhdpny0kos9w';

